import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "presentation__image" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Securely share files and folders with friends, family and colleagues for live collaboration. No email attachments required.", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("a", {
  class: "btn-1 anim",
  href: ""
}, "See how Fylo works", -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("a", {
  class: "btn-2 anim",
  href: ""
}, "Get Started", -1)
const _hoisted_9 = [
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "presentation__container",
    style: _normalizeStyle($setup.directionFlex)
  }, [
    _createElementVNode("figure", _hoisted_1, [
      _createElementVNode("img", {
        src: $props.image,
        alt: ""
      }, null, 8, _hoisted_2)
    ]),
    _createElementVNode("div", {
      class: "presentation__texts",
      style: _normalizeStyle($setup.containerStyle)
    }, [
      _createElementVNode("h1", {
        style: _normalizeStyle($setup.textStyle)
      }, _toDisplayString($props.title), 5),
      _createElementVNode("p", null, _toDisplayString($props.desc), 1),
      ($props.direction=='row')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_6))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
    ], 4)
  ], 4))
}